













import TemplateListing from "@/components/TemplateListing.vue";
import TemplatePicker from "@/components/TemplatePicker.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { TemplateListing, TemplatePicker }
})
export default class Main extends Vue {
  manifests = [
    [
      "https://github.com/MikeDombo/CXAPythonCLI/",
      "https://raw.githubusercontent.com/MikeDombo/CXAPythonCLI/master/manifest.cxa.yml"
    ],
    [
      "https://github.com/MikeDombo/CXAPythonFlask",
      "https://raw.githubusercontent.com/MikeDombo/CXAPythonFlask/master/manifest.cxa.yml"
    ]
  ];

  mounted() {
    document.title = "CXA | Home";
  }
}
